export default function (totalCharge, quantity, transactionId) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    content_ids: [transactionId],
    content_type: "product",
  }, {
    eventID: transactionId,
  });

  gtag("event", "conversion", {
    send_to: "AW-16853552450/rZQBCJbEgpccEMKas-Q-",
    value: totalCharge,
  });
}
